// Angular
import { DOCUMENT } from '@angular/common';
import { Component, HostBinding, OnInit, Input, Inject } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
// RxJS
import { filter } from 'rxjs/operators';
// Translate
import { TranslationService } from '../../../../../core/_base/layout';
import { LanguageSelectorService } from './language-selector.service';

interface LanguageFlag {
	lang: string;
	name: string;
	flag: string;
	active?: boolean;
}

@Component({
	selector: 'kt-language-selector',
	templateUrl: './language-selector.component.html',
})
export class LanguageSelectorComponent implements OnInit {
	// Public properties
	@HostBinding('class') classes = '';
	@Input() iconType: '' | 'brand';

	language: LanguageFlag;
	languages: LanguageFlag[] = [
		{
			lang: 'en',
			name: 'English',
			flag: './assets/media/flags/260-united-kingdom.svg'
		},
		{
			lang: 'pk',
			name: 'اردو',
			flag: './assets/media/flags/100-pakistan.svg'
		},
		// {
		// 	lang: 'es',
		// 	name: 'Spanish',
		// 	flag: './assets/media/flags/128-spain.svg'
		// },
		// {
		// 	lang: 'jp',
		// 	name: 'Japanese',
		// 	flag: './assets/media/flags/063-japan.svg'
		// },
		// {
		// 	lang: 'de',
		// 	name: 'German',
		// 	flag: './assets/media/flags/162-germany.svg'
		// },
		// {
		// 	lang: 'fr',
		// 	name: 'French',
		// 	flag: './assets/media/flags/195-france.svg'
		// },
	];

	/**
	 * Component constructor
	 *
	 * @param translationService: TranslationService
	 * @param router: Router
	 */
	constructor(private translationService: TranslationService, private router: Router,
		@Inject(DOCUMENT) private document: Document, private languageSelectorService:LanguageSelectorService) {
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit() {
		this.setSelectedLanguage();
		this.router.events
			.pipe(filter(event => event instanceof NavigationStart))
			.subscribe(event => {
				this.setSelectedLanguage();
			});
	}

	/**
	 * Set language
	 *
	 * @param lang: any
	 */
	setLanguage(lang) {
		this.languages.forEach((language: LanguageFlag) => {
			if (language.lang === lang) {
				language.active = true;
				this.language = language;
			} else {
				language.active = false;
			}
		});
		let htmlTag = this.document.getElementsByTagName("html")[0] as HTMLHtmlElement;
		htmlTag.dir = lang === "pk" ? "rtl" : "ltr";
		this.languageSelectorService.isRtl.next(true)
		this.translationService.setLanguage(lang);
		this.changeCssFile(lang)
	}

	changeCssFile(lang: string) {
		// let htmlTag = this.document.getElementsByTagName("html")[0] as HTMLHtmlElement;
		// let headTag = this.document.getElementsByTagName("head")[0] as HTMLHtmlElement;
		// let existingLink = htmlTag.lang;
		// let bundleName = lang;
		// // if (existingLink) {
		// //    existingLink = bundleName;
		// // } else {
		// 		// headTag.classList.add("mystyle");
		//    let newLink = this.document.createElement("link");
		//    newLink.rel = "stylesheet";
		//    newLink.type = "text/scss";
		// //    newLink.id = "langCss";
		//    newLink.href = lang === "pk" ? "styles-ur.scss":"styles.scss";
		//    headTag.appendChild(newLink);
		// // }
		const head = this.document.getElementsByTagName('head')[0];

		// let themeLink = this.document.getElementById(
		//   'client-theme'
		// ) as HTMLLinkElement;
		// if (themeLink) {
		//   themeLink.href = lang;
		// } else {
		//   const style = this.document.createElement('link');
		//   style.id = 'client-theme';
		//   style.rel = 'stylesheet';
		//   style.type = "text/scss";
		//   style.href = lang === "pk" ? "styles-ur.scss":"styles.scss";
	
		//   head.appendChild(style);
		// }
	//   }
		}

	/**
	 * Set selected language
	 */
	setSelectedLanguage(): any {
		this.setLanguage(this.translationService.getSelectedLanguage());
	}
}
